<template>

    <div class="container-fluid bg-dark footer mt-5 py-5 wow fadeIn" data-wow-delay="0.1s">
        <div class="container py-5">
            <div class="row g-5">
                <div class="col-lg-3 col-md-6">
                    <h1 class="text-primary">BistroBox</h1>
                    <p class="lh-lg mb-4">
                      Fresh, bold, and delicious meals made to keep you coming back for one bite more.
                    </p>
                    <div class="d-flex pt-3">
                        <a href="https://www.instagram.com/bistrobox.ng/" target="_blank"  class="btn btn-square btn-primary rounded-circle me-2"><i class="fab fa-instagram"></i></a>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <h4 class="text-primary mb-4">Short Menu</h4>
                    <a class="btn btn-link">Vanilla Milkshare</a>
                    <a class="btn btn-link">Grilled Chicken</a>
                    <a class="btn btn-link">Sharwama</a>
                    <a class="btn btn-link">Mocktails</a>
                    <a class="btn btn-link">Cocktails</a>
                </div>
                <div class="col-lg-3 col-md-6">
                    <h4 class="text-primary mb-4">Our Location</h4>
                    <p class="mb-2"><i class="fa fa-map-marker-alt text-primary me-3"></i>83 Evo Road GRA, Port Harcourt</p>
                    <p class="mb-2"><i class="fa fa-phone-alt text-primary me-3"></i>+234 704 350 4741</p>
                    <p class="mb-2"><i class="fa fa-envelope text-primary me-3"></i>info@bistrobox.com</p>
                </div>

                <div class="col-lg-3 col-md-6">
                    <h4 class="text-primary mb-4">Business Hours</h4>
                    <p class="mb-1">Monday - Sunday</p>
                    <h6 class="text-light">09:00 am - 12 Midnight</h6>
                </div>
            </div>
        </div>
    </div>
</template>